import { NgModule } from '@angular/core';
import { SearchBoxDirective } from './pyt_SearchBox/search-box.directive';
import { PytTblTopBoxComponent } from './pyt-tbl-top-box/pyt-tbl-top-box.component';
import { PytPaginationComponent } from './pytPagination/pyt-pagination/pyt-pagination.component';
import { PytCustTblPagerDirective } from './pytPagination/pyt-cust-tbl-pager.directive';
import { AbstractDebounceModule } from '@core/directives/debounce/abstract-debounce.module';
import { CdkDropDownModule } from '@core/customCDK/cdk-drop-down/cdk-drop-down.module';
import { CommonModule } from '@angular/common';
import { checkNullPipe } from '@core/pipes/check-null/check-null.pipe';

const decExport = [
    SearchBoxDirective,
    PytTblTopBoxComponent,
    PytPaginationComponent,
    PytCustTblPagerDirective,
    SearchBoxDirective,
]



@NgModule({
    imports: [
        CommonModule,
        // SharedModule,
        CdkDropDownModule,
        AbstractDebounceModule,
        checkNullPipe

        // ...importExport
    ],
    declarations: [...decExport],
    exports: [
        ...decExport,
        checkNullPipe

    ]
})
export class PytModule { }
